// CachePage.jsx
import React from "react";
import { useQueryClient } from "@tanstack/react-query";

export default function CachePage() {
  const queryClient = useQueryClient();
  const queries = queryClient.getQueryCache().getAll();

  return (
    <div style={{ padding: "1rem" }}>
      <h1>React Query Cache Viewer</h1>
      <ul>
        {queries.map((q) => (
          <li key={q.queryHash}>
            <strong>Key:</strong> {JSON.stringify(q.queryKey)}
            <br />
            <strong>Status:</strong> {q.state.status}
            <br />
            <strong>Data:</strong> <pre>{JSON.stringify(q.state.data, null, 2)}</pre>
          </li>
        ))}
      </ul>
    </div>
  );
}
